import { useRouteMatch } from "react-router-dom";
import { standardCheckoutRoutes, trialCheckoutRoutes } from "@jti/fe-common";
export const useFailedPaymentFlow = () => {
    const isStandardCheckoutFailedPaymentFlow = !!useRouteMatch(standardCheckoutRoutes.payment.failedPaymentPath);
    const isFailedPaymentFlowTrial = !!useRouteMatch(trialCheckoutRoutes.payment.failedPaymentPath);
    const isFailedPaymentFlow = isStandardCheckoutFailedPaymentFlow || isFailedPaymentFlowTrial;
    return { isFailedPaymentFlow };
};
//# sourceMappingURL=useFailedPaymentFlow.js.map